import axios from 'axios'

axios.defaults.baseURL = 'https://gestao.appfacilita.com/wp-json/v1/facilita/?tipo=construtoras&version=7'